module.exports = __webpack_public_path__ + "img/delete-file.b396039f.svg";